import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_4 = {
  key: 2,
  class: "mb-3"
}
const _hoisted_5 = {
  key: 3,
  class: "mb-3"
}
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "d-flex mt-4 justify-end" }

export function render(_ctx, _cache) {
  const _component_v_file_input = _resolveComponent("v-file-input")
  const _component_DatePicker = _resolveComponent("DatePicker")
  const _component_v_switch = _resolveComponent("v-switch")
  const _component_v_text_field = _resolveComponent("v-text-field")
  const _component_CaseSolutionInput = _resolveComponent("CaseSolutionInput")
  const _component_BaseButton = _resolveComponent("BaseButton")
  const _component_v_form = _resolveComponent("v-form")
  const _component_NotificationDialog = _resolveComponent("NotificationDialog")

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("h1", null, [
      _cache[8] || (_cache[8] = _createTextVNode(" Please enter more information about this case ", -1)),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" Case title: " + _toDisplayString(_ctx.caseModel.title), 1)
    ]),
    _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "my-3" }, "Please enter the following information:", -1)),
    _createVNode(_component_v_form, {
      ref: "form",
      onSubmit: _withModifiers(_ctx.submit, ["prevent"])
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block mb-1" }, " Please upload the final answer that was sent to the customer as .pdf, .doc or .msg file.* ", -1)),
          _createVNode(_component_v_file_input, {
            "truncate-length": "15",
            modelValue: _ctx.solveData.file,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.solveData.file) = $event)),
            variant: "outlined",
            density: "compact",
            placeholder: "Upload a file",
            accept: ".doc,.docx,.pdf,.msg",
            rules: [(v) => !!v],
            "hide-details": ""
          }, null, 8, ["modelValue", "rules"])
        ]),
        (_ctx.isBoardCase)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "d-block mb-1" }, " Date of final reply to the customer: * ", -1)),
              _createVNode(_component_DatePicker, {
                modelValue: _ctx.solveData.finalReplyDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.solveData.finalReplyDate) = $event)),
                "required-field": true,
                "hide-details": "",
                density: "compact",
                placeholder: "Select date of the final reply"
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isBoardCase)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "d-block mb-1" }, "Sorry activity?", -1)),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.solveData.sorryActivity,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.solveData.sorryActivity) = $event)),
                "hide-details": ""
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isBoardCase)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block mb-1" }, "Did you call the customer?", -1)),
              _createVNode(_component_v_switch, {
                modelValue: _ctx.solveData.contactedViaPhone,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.solveData.contactedViaPhone) = $event)),
                "hide-details": ""
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.isBoardCase)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block mb-1" }, " NSC Case ID and/or Case Queue Name: ", -1)),
              _createVNode(_component_v_text_field, {
                modelValue: _ctx.solveData.nscCaseId,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.solveData.nscCaseId) = $event)),
                placeholder: "NSC Case ID",
                variant: "outlined",
                density: "compact",
                "hide-details": ""
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block mb-1" }, "VIN#: *", -1)),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.solveData.vin,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.solveData.vin) = $event)),
            placeholder: "VIN",
            rules: [(v) => !!v],
            variant: "outlined",
            density: "compact"
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mb-2" }, " Each code level set must be coded with at least one solution. ", -1)),
          _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_CaseSolutionInput, {
            caseModel: _ctx.caseModel,
            solutions: _ctx.solveData.solutions,
            "onUpdate:solutions": _cache[6] || (_cache[6] = $event => ((_ctx.solveData.solutions) = $event))
          }, null, 8, ["caseModel", "solutions"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_BaseButton, {
            width: 200,
            submit: "",
            disabled: _ctx.loading
          }, {
            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
              _createTextVNode(" Submit ", -1)
            ]))]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_NotificationDialog, {
      visible: _ctx.validationErrorVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = $event => ((_ctx.validationErrorVisible) = $event)),
      title: "Validation Error!",
      message: "At least one solution must be specified for each set of code levels, and all required fields for the solution must be completed."
    }, null, 8, ["visible"])
  ]))
}